<template>
  <div>
    <div class="fixed" v-if="!isWx">
      <div class="top_header">
        <div class="m_flex_box flex_vc flex_jz">
          <div class="m_flex_box flex_vc">
            <van-icon
              name="arrow-left"
              class="mar_r"
              @click="goback"
              size="0.4rem"
            />
          </div>
          <div
            style="text-align: center; font-size: 0.35rem; margin-left: -0.2rem"
          >
            物业资讯
          </div>
          <div></div>
        </div>
      </div>
    </div>
    <div class="fixed_pad"  :style="{paddingTop:(!isWx?'1.9rem':'0.9rem')}"></div>
    <div class="tab"  :style="{top:(!isWx?'0.9rem':'0')}">
      <span
        :class="formData.lxbh === '003001' ? 'active' : ''"
        @click="changeTab('003001')"
        >政策法规</span
      >
      <span
        :class="formData.lxbh === '002001' ? 'active' : ''"
        @click="changeTab('002001')"
        >信息公开</span
      >
      <span
        :class="formData.lxbh === '005001' ? 'active' : ''"
        @click="changeTab('005001')"
        >典型事例</span
      >
      <span
        :class="formData.lxbh === '007001' ? 'active' : ''"
        @click="changeTab('007001')"
        >办事指南</span
      >
    </div>
    <!-- <div v-if="list.length != 0"> -->
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <van-list
        v-if="formData.lxbh != '007001'"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div
          class="data"
          @click="jumpPage(item.bh)"
          v-for="item in list"
          :key="item.bh"
        >
          <div>{{ item.zbt }}</div>
          <div class="flex_c">
            <div>
              <span>来源:</span>
              <span>-</span>
            </div>
            <div>
              <span>作者:</span>
              <span>-</span>
            </div>
            <div>
              <span>日期:</span>
              <span>{{ item.fbsj | format() }}</span>
            </div>
          </div>
        </div>
      </van-list>
      <van-list
        v-else
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div
          class="data"
          @click="jumpPage(item.bh)"
          v-for="item in list"
          :key="item.bh"
        >
          <div>{{ item.bsznbt }}</div>
          <div class="flex_c">
            <div>
              <span>来源:</span>
              <span>-</span>
            </div>
            <div>
              <span>作者:</span>
              <span>-</span>
            </div>
            <div>
              <span>日期:</span>
              <span>{{ item.cjsj | format() }}</span>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <!-- </div> -->
    <!-- <div v-else style="text-align: center">
      <img src="@/assets/img/nodata.png" alt="" class="noData" />
    </div> -->
  </div>
</template>
<script>
import qs from "qs";
export default {
  data() {
    return {
      isLoading: false,
      loading: false,
      finished: false,
      list: [],
      formData: {
        pageSize: 10,
        pageIndex: 0,
        lxbh: "003001",
        sfhtp: 0,
      },
      isWx: this.$route.query.wx || false,
      timer: null,
      isApp: this.$route.query.isApp || false,
    };
  },
  created() {
    // this.onLoad()
  },
  filters: {
    format(data) {
      return data.split(" ")[0];
    },
  },
  methods: {
    onRefresh() {
      this.finished = false;
      this.loading = false;
      this.formData.pageIndex = 0;
      this.list = [];
      this.onLoad(1);
    },
    goback() {
      if ((this.isApp && this.isApp != "false") || this.isApp == "true") {
        let u = navigator.userAgent;
        let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //g
        let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        if (isAndroid) {
          window.android.goback(); // 调用原生app的函数
        }
        if (isIOS) {
          window.webkit.messageHandlers.goback.postMessage(null);
        }
        // window.webkit.messageHandlers.goback.postMessage(null);
      } else {
        this.$router.go(-1);
      }
    },
    onLoad(type) {
      if (!this.timer) {
        this.timer = setTimeout(() => {
          this.timer = null;
        }, 50);
        if (this.formData.lxbh == "007001") {
          this.$http
            .post("house/wyts/getWyBszn.do", qs.stringify(this.formData))
            .then((res) => {
              if (res.success) {
                if (type) {
                  this.isLoading = false;
                }
                this.list = this.list.concat(res.obj);
                this.loading = false;
                this.$set(
                  this.formData,
                  "pageIndex",
                  this.formData.pageIndex + 1
                );
                if (res.obj.length == 0) {
                  this.finished = true;
                }
              } else {
                this.finished = true;
              }
            });
        } else {
          this.$http
            .post("house/wyts/getWyNews.do", qs.stringify(this.formData))
            .then((res) => {
              if (res.success) {
                if (type) {
                  this.isLoading = false;
                }
                this.list = this.list.concat(res.obj.result);
                this.loading = false;
                this.$set(
                  this.formData,
                  "pageIndex",
                  this.formData.pageIndex + 1
                );
                if (res.obj.result.length == 0) {
                  this.finished = true;
                }
              } else {
                this.finished = true;
              }
            });
        }
      }
    },
    assignmentTooken() {
      if ((this.isApp && this.isApp != "false") || this.isApp == "true") {
        var ua = navigator.userAgent;
        var uaList = ua.split(" ");
        var token = "";
        for (var i = 0; i < uaList.length; i++) {
          if (uaList[i].indexOf("token") > -1) {
            token = uaList[i].split("=")[1];
            break;
          }
        }
        this.formData.appToken = token;
      } else {
        if ((this.isWx && this.isWx != "false") || this.isWx == "true") {
          if (window.sessionStorage.getItem("wxAppToken")) {
            this.formData.appToken = sessionStorage.getItem("wxAppToken");
          }
        } else {
          if (JSON.parse(window.localStorage.getItem("tokenObj"))) {
            this.formData.appToken = JSON.parse(
              localStorage.getItem("tokenObj")
            ).appToken;
          }
        }
      }
    },
    changeTab(num) {
      this.formData.lxbh = num;
      this.list = [];
      this.formData.pageIndex = 0;
      this.onLoad();
    },
    jumpPage(id) {
      this.$router.push({
        path: "/consultingDetail",
        query: { type: id, classType: this.formData.lxbh,wx:this.isWx },
      });
    },
  },
};
</script>  
<style lang="less" scoped>
.noData {
  width: 60%;
  margin-top: 30%;
}
.fixed_pad {
  padding-top: 1.9rem;
}
.top_header {
  height: 0.5rem;
  padding: 0.2rem 0rem;
  width: 7.04rem;
  margin: 0 auto;
}
.fixed {
  border-bottom: 1px solid #f5f5f5;
  background-color: #fff;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  z-index: 9;
  .top_normal {
    height: 100%;
    i {
      font-size: 0.32rem;
    }
  }
}
.tab {
  position:fixed;
  top:0.9rem;
  left:0;
  right:0;
  z-index:99;
  height: 1rem;
  background-color: #fff;
  display: flex;
  span {
    flex: 1;
    font-weight: 800;
    font-size: 0.3rem;
    margin: 0.3rem;
    position: relative;
    text-align: center;
  }
  .active {
    color: #3072f5;
    font-size: 0.3rem;
    &:after {
      content: "";
      bottom: -0.2rem;
      position: absolute;
      display: block;
      left: 50%;
      // margin-left: -0.2rem;
      transform: translateX(-50%);
      background-color: #3072f5;
      width: 0.7rem;
      height: 0.04rem;
    }
  }
}
.data {
  padding: 0.3rem 0.35rem 0.1rem 0.35rem;
  border-bottom: 1px solid #ccc;
  font-size: 0.3rem;
  .flex_c {
    display: flex;
    padding: 0.2rem 0;
    color: #ccc;
    div {
      flex: 1;
    }
  }
}
</style>